import { Navigate } from "react-router-dom";
import { useBusinessAuthContext } from "./useBusinessAuthContext";
import { isTokenExpired  } from "../../api/helpers";

const BusinessProtectedRoute = ({ children }) => {
  const { business, authChecked } = useBusinessAuthContext();

  if (!authChecked) {
    return <div>Loading...</div>;
  }

  if (!business?.token || isTokenExpired(business.token)) {
    localStorage.removeItem("business");
    return <Navigate to="/business/login" replace />;
  }

  return children;

  /*return business
    ? children
    : <Navigate to="/business/login" replace />;*/
};

export default BusinessProtectedRoute;